import ApprentiDateRupture from '@/generated/controls/apprenti/ApprentiDateRupture.vue';
import { defineComponent } from "vue";

export default defineComponent({ components: {},
    extends: ApprentiDateRupture
})
